<template>
  <boxwrap class="freeboard--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>

        <button
          class="btn--create"
          title="create"
          @click="select('new')"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          v-if="selected.length > 0"
          @click="deleteData()"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          title="restore"
          v-if="selected.length > 0"
          @click="restore()"
        >
          <i class="ico--restore"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    :checked="selectAll"
                    @click="checkAll(boards)"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                @click.native="sort('id')"
                v-if="checkCol('id', tblSetting)"
              >
                no
              </tbl-td>

              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              >
                created at
              </tbl-td>

              <tbl-td
                name="title"
                :sort="true"
                @click.native="sort('title')"
                v-if="checkCol('title', tblSetting)"
              >
                title
              </tbl-td>

              <tbl-td
                name="view-count"
                v-if="checkCol('views', tblSetting)"
              >
                views
              </tbl-td>

              <tbl-td
                name="login-id"
                v-if="checkCol('login_id', tblSetting)"
              >
                login id
              </tbl-td>

              <tbl-td
                name="login-name"
                v-if="checkCol('login_name', tblSetting)"
              >
                login name
              </tbl-td>

              <tbl-td
                name="level"
                v-if="checkCol('level', tblSetting)"
              >
                level
              </tbl-td>

              <tbl-td
                name="agent"
                v-if="checkCol('agent', tblSetting)"
              >
                agent
              </tbl-td>

              <tbl-td
                name="user-type"
                :sort="true"
                v-if="checkCol('user_type', tblSetting)"
              >
                user type
              </tbl-td>

              <tbl-td
                name="can-comment"
                v-if="checkPermission && checkCol('can_comment', tblSetting)"
              >
                can comment
              </tbl-td>

              <tbl-td
                name="comment-count"
                v-if="checkCol('comment_count', tblSetting)"
              >
                comment count
              </tbl-td>

              <tbl-td
                name="updated-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                name="deleted-at"
                :sort="true"
                @click.native="sort('deleted_at')"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                deleted at
              </tbl-td>

              <tbl-td
                name="delete-edit"
                v-if="checkPermission  &&  checkCol('show', tblSetting)"
              >
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(row, x) in boards"
              @click.native="select(row)"
              :key="row.id"
              :class="{'is-deleted': row.deleted_at }"
            >
              <tbl-td name="checkbox" @click.native.stop>
                <checkbox>
                  <input type="checkbox"
                    v-model="selected"
                    :value="row.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                v-if="checkCol('id', tblSetting)"
              >
                {{ generateNumber(x, params.page, params.rows, params.sort, count || 0) }}
              </tbl-td>

              <tbl-td
                name="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                <span>{{ row.created_at | date }}</span>
              </tbl-td>

              <tbl-td
                name="title"
                v-if="checkCol('title', tblSetting)"
              >
                <i class="admin--icon" v-if="row.admin && !row.user">A</i>
                <i class="bets--icon" v-if="row.betslips.length">B</i>
                <span v-html="row.title"></span>
              </tbl-td>

              <tbl-td
                name="view-count"
                v-if="checkCol('views', tblSetting)"
              >
                <span v-if="row.views">{{row.views.total}}</span>
                <span v-else>0</span>
              </tbl-td>

              <tbl-td
                name="login-id"
                v-if="checkCol('login_id', tblSetting)"
                @click.native.stop
                @click.native="row.user ? openUser(row.user.id,'info/undeleted') : null"
              >
                <span v-if="row.user">
                  {{ row.user.login_id }}
                </span>

                <span v-if="row.admin">
                  {{ row.admin.login_id }}
                </span>
              </tbl-td>

              <tbl-td
                name="login-name"
                v-if="checkCol('login_name', tblSetting)"
                @click.native.stop
                @click.native="row.user ? openUser(row.user.id,'bet-history/all') : null"
              >
                <span v-if="row.user">
                  {{ row.user.login_name }}
                </span>

                <span v-if="row.admin">
                  {{ row.admin.login_name }}
                </span>
              </tbl-td>

              <tbl-td
                name="level"
                v-if="checkCol('level', tblSetting)"
              >
                <span v-if="row.user">
                  lvl. {{ row.user.level_id }}
                </span>

                <span v-if="row.admin">
                  lvl. {{ row.admin.level_id }}
                </span>
              </tbl-td>

              <tbl-td
                name="agent"
                v-if="checkCol('agent', tblSetting)"
              >
                <span v-if="row.user">
                  {{row.user.agent_login_id}}
                </span>
                <span  v-else>-</span>
              </tbl-td>

              <tbl-td
                name="user-type"
                v-if="checkCol('user_type', tblSetting)"
              >
                <span v-if="row.user && row.user.isTester">test user</span>
                <span v-if="row.user && !row.user.isTester">user</span>
                <span v-if="!row.user && row.admin">admin</span>
              </tbl-td>

              <tbl-td
                name="can-comment"
                v-if="checkPermission && checkCol('can_comment', tblSetting)"
              >
                <checkbox
                  type="toggle"
                  class="toggle--inverted"
                  toggleA="enabled"
                  toggleB="disabled"
                  @click.native.stop.prevent="update({ can_comment: !row.can_comment }, row.id)"
                >
                  <input
                    type="checkbox"
                    v-model="row.can_comment"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="comment-count"
                v-if="checkCol('comment_count', tblSetting)"
              >
                <span>{{ row.comments.cnt }}</span>
              </tbl-td>

              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                <span>{{ row.updated_at | date }}</span>
              </tbl-td>

              <tbl-td
                name="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                <span> {{ row.deleted_at | date }} </span>
              </tbl-td>

              <tbl-td
                name="delete-edit"
                @click.native.stop
                v-if="checkPermission && checkCol('show', tblSetting)"
              >
                <checkbox
                  type="toggle"
                  :toggleA="!row.is_hidden ? 'show' : 'hide'"
                  :toggleB="!row.is_hidden ? 'show' : 'hide'"
                  @click.native.stop.prevent="update({ is_hidden: !row.is_hidden }, row.id)"
                >
                  <input
                    type="checkbox"
                    v-model="row.is_hidden"
                  />
                </checkbox>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>
        <tbl-footer>
          <pagination
            :total="count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>

      <board-ads
        class="freeboard-ads"
        :class="{ 'is-active' : showAds }"
      >
      </board-ads>
    </boxwrap-contents>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { boards } from '@/socket'
import { mapGetters, mapActions, mapState } from 'vuex'
import _ from 'lodash'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import TextArea from '@/components/base/TextArea'

import BoardAds from '@/views/boards/BoardAds'

import '@/components/base/input/InputSuggestion.js'
import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

export default {
  name: 'freeboard',

  components: {
    Pagination,
    Checkbox,
    Modal,
    Search,
    CheckDataList,
    TextArea,
    BoardAds
  },

  mixins: [swal, checkAll],

  data () {
    return {
      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      showTblSettings: false,
      showAds: false,

      user: null,
      selected: [],
      selectAll: false,

      filterBy: [
        {
          value: 'login_id',
          display: 'login id'
        },

        {
          value: 'login_name',
          display: 'login name'
        },

        {
          value: 'title',
          display: 'title'
        },

        {
          value: 'created_at',
          display: 'date posted'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'Posted on'
        }
      ],

      tblSetting: 'freeboard_list',
      allCols: [
        {
          display: 'no',
          value: 'id'
        },
        {
          display: 'created at ',
          value: 'created_at'
        },
        {
          display: 'title',
          value: 'title'
        },
        {
          display: 'views',
          value: 'views'
        },
        {
          display: 'login id',
          value: 'login_id'
        },
        {
          display: 'login name',
          value: 'login_name'
        },
        {
          display: 'level',
          value: 'level'
        },
        {
          display: 'agent',
          value: 'agent'
        },
        {
          display: 'user type',
          value: 'user_type'
        },
        {
          display: 'can comment',
          value: 'can_comment'
        },
        {
          display: 'comment count',
          value: 'comment_count'
        },
        {
          display: 'show',
          value: 'show'
        },
        {
          display: 'updated at ',
          value: 'updated_at'
        },
        {
          display: 'deleted at ',
          value: 'deleted_at'
        }
      ]
    }
  },

  async created () {
    boards.on('new', () => {
      this.search()
    })
    boards.on('update', () => {
      this.search()
    })
    this.params = this.generate(this.$route.query)
    this.search()
  },

  watch: {
    async $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      await this.search(this.generate($router.query))
    }
  },

  beforeDestroy () {
    boards.removeListener('new')
    boards.removeListener('update')
  },

  computed: {
    ...mapState('freeBoard', ['boards', 'count', 'comments']),
    ...mapState('freeBoard', ['ads', 'createErr']),
    ...mapState('test-user', { testUsers: 'users' }),
    ...mapState('user', ['users']),
    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  methods: {
    ...mapActions('freeBoard', {
      getBoards: 'get',
      updateBoard: 'update',
      getBoardCount: 'getCount',
      deleteBoard: 'delete'
    }),

    ...mapActions('test-user', { getTestUsers: 'get' }),
    ...mapActions('user', { findUser: 'find', getUsers: 'get' }),

    async searchUsers (q) {
      let params = { status: 'c', limit: 200 }

      if (q) {
        params.filter_by = 'login_id'
        params.q = q
        params.sort_by = 'id'
        params.sort = 'asc'
      }

      if (this.postAs === 'test') {
        await this.getTestUsers({ status: 'confirmed', params })
        this.userList = this.testUsers
      } else {
        await this.getUsers({ status: 'confirmed', params })
        this.userList = this.users
      }
    },

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ path: '/freeboards', query: this.params })
    },

    reset () {
      if (this.$refs.image) {
        this.$refs.image.value = ''
      }

      this.postUser = ''
      this.editBoard = {
        title: '',
        content: '',
        image: null,
        editBoard: null,
        can_comment: false,
        is_hidden: false,
        user_id: null
      }
    },

    async search (query) {
      this.params = query || this.params

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getBoards(this.params)

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.boards.length) {
        this.isEmpty = true
      }

      await this.getBoardCount(this.params)
    },

    async update (data, id) {
      let success = async () => {
        for (var key in data) {
          if (key === 'can_comment' || key === 'is_hidden') {
            data[key] = !data[key] ? 0 : 1
          }
        }

        if (this.selected.length && !id) {
          for (var x = 0; x < this.selected.length; x++) {
            let row = this.boards.find((e) => {
              return e.id === this.selected[x]
            })

            data.user_id = row.user_id
            data.admin_id = row.admin_id

            await this.updateBoard({ id: this.selected[x], data })
          }

          this.selectAll = false
          return
        }

        if (id) {
          this.updateBoard({ id, data })
        }
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Modify')
    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      // this.search()
      this.$router.push({ query: this.params })
    },

    async deleteData () {
      let success = async () => {
        for (var x = 0; x < this.selected.length; x++) {
          await this.deleteBoard(this.selected[x])
        }

        this.selectAll = false
        this.selected = []
        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Delete ?')
    },

    async restore () {
      let success = async () => {
        let data = {}
        for (var x = 0; x < this.selected.length; x++) {
          let row = this.boards.find((e) => {
            return e.id === this.selected[x]
          })

          data.user_id = row.user_id
          data.admin_id = row.admin_id
          data.deleted_at = null

          await this.updateBoard({ id: this.selected[x], data })
        }

        this.selectAll = false
        this.selected = []
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Restore?')
    },

    select (row) {
      let w = 800
      if (row.betslips && row.betslips.length) {
        w = 1200
      }
      let id = ''
      if (row === 'new') {
        id = 'new'
      } else {
        id = row.id
      }
      window.open(
        `${process.env.VUE_APP_URL}/freeboard/${id}`,
        '',
        `width=${w},height=${window.innerHeight}`
      )
    },

    openUser (id, subtype) {
      window.open(
        `${process.env.VUE_APP_URL}/user/${id}/${subtype}`,
        '',
        `width=${1400},height=${window.innerHeight}`
      )
    }
  }
}
</script>
